import React from 'react';
const SelectList = (props) => { 
    let isSelected = false;
    return (
        <select id={props.id} onChange={props.onChangeHandler} name={props.name} className="form-select" style={props.style} disabled={props.disabled} value={props.value}>
            {
                props.dataSource && props.dataSource.map((listItem, index) => {
                    isSelected = false;
                    if (listItem.Value == props.selectedData) {
                        isSelected = true;
                    }

                    if (isSelected)
                        return <option key={index} value={listItem.Value} selected>{listItem.Name}</option>
                    else
                        return <option key={index} value={listItem.Value}>{listItem.Name}</option>
                })
            }
        </select>
    );
};
export default SelectList;
